import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { everythingIncluded, noMore } from '../data/includes';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-terracotta-deep text-paper" data-id="element-96" data-mp="85fc0zc93r28">
      <div className="max-w-4xl mx-auto" data-id="element-97" data-mp="87a20s2dq9d6">
        <div className="text-center mb-16" data-id="element-98" data-mp="m4f5qlemew59">
          <p className="text-paper/70 font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-99" data-mp="m340si9fvick">
            Your Next Teaching Week
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-100" data-mp="vv9pnj4e9jnj">
            You can spend the next few days building your drawing classes from
            scratch...
            <br data-id="element-101" data-mp="2h5koi0tkm5oa" />
            <span className="text-[#F2C9A8]" data-id="element-102" data-mp="2m2udjfd1sfbl">
              Or you can walk into the studio with everything prepared,
              organized, and ready to teach.
            </span>
          </motion.h2>

          <ul className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/10 p-8 rounded-2xl border border-paper/20" data-id="element-103" data-mp="2v3setpw3q8qh">
            {noMore.map(item => <li key={item} className="flex items-start gap-3" data-id="element-104" data-mp="300sp6czzhxne">
                <span className="text-[#F2C9A8] mt-1" aria-hidden="true" data-id="element-105" data-mp="34udbh7s7t36r">
                  ✦
                </span>
                <span className="text-paper/90" data-id="element-106" data-mp="39rvn55xm9wig">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl mb-2" data-id="element-107" data-mp="3etcn8z8a1exz">
            Drawing Teacher Ready doesn't make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-[#F2C9A8] mb-6" data-id="element-108" data-mp="3iqqtci0nv6lr">
            You're already a great teacher.
          </p>
          <p className="text-xl text-paper/90" data-id="element-109" data-mp="1epihxjr7dpg4">
            What Drawing Teacher Ready does is give you the time and tools to
            make that greatness visible in every class you teach.
          </p>
        </div>

        <div className="bg-paper text-charcoal rounded-3xl p-8 md:p-12" data-id="element-110" data-mp="1npou92b60jdp">
          <h3 className="text-2xl font-bold mb-6 text-center border-b border-warmgray pb-6" data-id="element-111" data-mp="22ekw2hmmp05v">
            Everything Included
          </h3>

          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-112" data-mp="1xeykecmg7rz6">
            {everythingIncluded.map(item => <li key={item} className="flex items-center gap-3" data-id="element-113" data-mp="2beq2aog35sig">
                <Check size={18} className="text-terracotta shrink-0" aria-hidden="true" data-id="element-114" data-mp="27ez80arcou96" />
                <span className="text-sm text-charcoal-soft" data-id="element-115" data-mp="czwmsp9c3yc2">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-116" data-mp="2vg8w1ff0raw">
            <div className="mb-8 p-6 bg-sand rounded-xl border border-warmgray italic text-charcoal-soft text-lg" data-id="element-117" data-mp="2wrlmqqu99e5">
              "The best time to have this teaching library was before your
              first drawing class.
              <br data-id="element-118" data-mp="3p9q1ynuaini0" />
              <span className="text-terracotta-deep font-bold not-italic" data-id="element-119" data-mp="3uadqn2v1qs92">
                The second best time is today.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold mb-2" data-id="element-120" data-mp="3ffpr05cbuo1d">
              Drawing Teacher Ready
            </p>
            <p className="text-sm text-charcoal-muted mb-8" data-id="element-121" data-mp="36cycfwo5nc5i">
              6 complete volumes of drawing lessons ready to teach, created to
              help drawing teachers plan less, teach with confidence, and keep
              every class technically rich and professionally structured.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6 bg-burnt-light hover:bg-terracotta-dark" data-id="element-122" data-mp="19ky8ew9w8bv1">
              GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-charcoal-muted" data-id="element-123" data-mp="2vnshye00wwjk">
              <span data-id="element-124" data-mp="2rn0bttmg77ri">7-day money-back guarantee</span>
              <span data-id="element-125" data-mp="2mof8vmfta9zd">·</span>
              <span data-id="element-126" data-mp="2mpqmsf2z0y47">Instant access</span>
              <span data-id="element-127" data-mp="2mqs0ysfaa0q5">·</span>
              <span data-id="element-128" data-mp="2hy8mlt8rv1ka">Pay once, use forever</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}